import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-97">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 z-50" data-id="element-98" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-99">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-zinc-900 border border-cyan-500/20 rounded-lg shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" data-id="element-100">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-cyan-500/20" data-id="element-101">
                <h2 className="text-2xl font-bold text-white" data-id="element-102">{title}</h2>
                <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors p-2 hover:bg-zinc-800 rounded-lg" aria-label="Cerrar" data-id="element-103">
                  <XIcon className="w-6 h-6" data-id="element-104" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-88px)]" data-id="element-105">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}